import axios from "axios";
import { API, getAuthHeader } from "@/App";

export const capi = (method, path, data, extra = {}) =>
  axios({ method, url: `${API}${path}`, data, headers: getAuthHeader(), ...extra }).then((r) => r.data);

export const errMsg = (e) => e?.response?.data?.detail || e?.message || "Something went wrong";

const CHUNK = 4 * 1024 * 1024;
export const MAX_FILE = 50 * 1024 * 1024;

export const uploadFile = async (file, onProgress) => {
  if (file.size > MAX_FILE) throw new Error("Files can be up to 50 MB");
  const { upload_id } = await capi("post", "/chat/upload/init", { name: file.name, size: file.size, type: file.type });
  const n = Math.max(1, Math.ceil(file.size / CHUNK));
  for (let i = 0; i < n; i++) {
    const fd = new FormData();
    fd.append("index", String(i));
    fd.append("chunk", file.slice(i * CHUNK, (i + 1) * CHUNK), "part");
    await capi("post", `/chat/upload/${upload_id}/chunk`, fd);
    onProgress?.(Math.round(((i + 1) / n) * 95));
  }
  const meta = await capi("post", `/chat/upload/${upload_id}/complete`);
  onProgress?.(100);
  return meta;
};

export const fsize = (b) => (!b ? "" : b < 1024 * 1024 ? `${(b / 1024).toFixed(0)} KB` : `${(b / 1048576).toFixed(1)} MB`);

export const ftime = (iso) => new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

export const fday = (iso) => {
  const d = new Date(iso);
  const t = new Date();
  const y = new Date(); y.setDate(t.getDate() - 1);
  if (d.toDateString() === t.toDateString()) return "Today";
  if (d.toDateString() === y.toDateString()) return "Yesterday";
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

export const initials = (n) => String(n || "?").split(" ").filter(Boolean).map((w) => w[0]).slice(0, 2).join("").toUpperCase();
